<template>
	<div class="dtiail_XGYD">
		<div class="dtiail_XGYD_title">相关阅读</div>
		<div class="_XGYD_list">
			<div class="XGYD_list_left">
				<ul>
					<router-link tag="li" v-for="(item,index) in aboutList" :key="index" class="qydq_warp"
						:to="{path: '/hyzx/detail', query: {id:item.id,title:item.title}}">
						{{item.title}}
					</router-link>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data(){
			return{
				aboutList:[],       //相关阅读
			}
		},
		async mounted() {
			//数据获取太慢
			let res = await http.get('api/industry/content?id=1645')
			this.aboutList = res.data.data.about
		}
	}
</script>

<style>
	.dtiail_XGYD {
		width: 96%;
		margin: 0 auto;
		margin-top: 40px;
	}

	.dtiail_XGYD_title {
		font-size: 14px;
		font-weight: 600;
		padding-bottom: 4px;
	}

	._XGYD_list {
		margin-top: 10px;
	}

	._XGYD_list>div {
		float: left;
		width: 100%;
	}

	._XGYD_list>>ul {
		margin-left: 20px;
	}

	._XGYD_list>>ul>li {
		list-style: disc !important;
		cursor: pointer;
		font-size: 15px;
		line-height: 25px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	
	.XGYD_list_left>ul{
		padding: 0px;
		margin: 0px;
	}
	
	.XGYD_list_left>ul>li{
		list-style: none;
	}
	
	.XGYD_list_rg{
	    margin-left: 3%;
	}
</style>
